import { useQuery, useQueryClient, useMutation } from 'react-query';
import { CookieConsent } from '@uds/uteals';
import PaddingBox, { Side } from '@uds/padding-box';
import { WubLoader } from '@uds/penders';
import { cssTheme } from '@uds/theme-utils';
import './inlineprivacy_1xm5vhe.css';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Typelockup, Heading03, Heading06, BodyCopy, classNames as classNames$5, Heading04, Heading02 } from '@uds/typography';
import Message from '@uds/message';
import TextButton, { Size } from '@uds/text-button';
import { useIntl } from 'react-intl';
import './richtextmessage.stylesheet_1qufvep.css';
import { cx as cx$1 } from 'linaria';
import './header.stylesheet_1n1n7jq.css';
import { Formik, Form, useFormikContext } from 'formik';
import Button, { Status, Kind, CTAGroup } from '@uds/button';
import { after } from '@ux/promise';
import * as React from 'react';
import { useRef, Suspense, useMemo, useEffect, useState, createElement } from 'react';
import { useBrandConfig } from '@ux/whitelabel';
import { useWindow, useDocument } from '@uds/hooks';
import cookies, { get } from 'browser-cookies';
import './togglegroup.stylesheet_v772eu.css';
import { Panel } from '@uds/panel';
import { FormikSwitch } from '@uds/formik-adapter';
import Colorway, { Colorways } from '@uds/colorway';
import './toggle.stylesheet_10yb2re.css';
import { useCloseModal, usePush, ModalRoute } from 'react-modal-router';
import { Modal } from '@uds/modal';
import deepEqual from 'fast-deep-equal';
import AnimateHeight from 'react-animate-height';
import './modalform.stylesheet_15t39xf.css';
import { updatedDiff } from 'deep-object-diff';
import { Container } from '@uds/grid';
import { useErk, useSmirk } from '@uds/reactive-knowledge';
import { authDriver, getCustomer, useAuth } from '@ux/auth';
import './actionstrip_19tmy1i.css';
import { useCreateConfirmationModal } from '@uds/confirmation';
import './communicationform_yd808.css';
import { pipe, xray, json, bodyOnly, fetch, Method } from '@ux/drivers';
import { v4 } from 'uuid';
import './formsection.stylesheet_16kf50b.css';
import './sectionintro_1qkzgmo.css';

const root$2 = {
  default: "d5ilb50",
  disabled: "dh2ztio"
};
const panel = "p1aum6cs";
const inner = "i1rnqtr6";
const text$1 = "tfftq8q";
const getClassNames$2 = props => ({
  root: cx$1(root$2.default, props.disabled && root$2.disabled),
  panel,
  inner,
  text: text$1
});

let FormKey;
(function (FormKey) {
  FormKey["INLINE"] = "inline";
  FormKey["MODAL"] = "modal";
  FormKey["COMMUNICATION"] = "communication";
})(FormKey || (FormKey = {}));
const Toggle = _ref => {
  let {
    intlNamespace,
    name,
    disabled,
    showSwitch = true,
    formKey
  } = _ref;
  const ref = useRef(null);
  const classNames = getClassNames$2({
    disabled
  });
  // Formik will not work correctly if we render two inputs with the same id on the same page
  // Therefore prefixing so we can render both modal and inline form on the same page if need be
  const id = `${formKey}-${name}`;
  const onClick = () => {
    if (ref.current != null) {
      ref.current.click();
      ref.current.focus();
    }
  };
  const describedBy = `${id}-describedby`;
  return (
    /*#__PURE__*/
    // 👇 the on click handler here is only to make the card work as a label for the switch
    // The keyboard events are handled by the switch itself
    jsx("span", {
      className: classNames.root,
      onClick: onClick,
      role: "presentation",
      children: /*#__PURE__*/jsx(Panel, {
        className: classNames.panel,
        children: /*#__PURE__*/jsx(PaddingBox, {
          children: /*#__PURE__*/jsxs(Colorway, {
            colorway: Colorways.LIGHT,
            className: classNames.inner,
            children: [/*#__PURE__*/jsx("section", {
              className: classNames.text,
              children: /*#__PURE__*/jsx(Typelockup, {
                heading: /*#__PURE__*/jsx(Heading03, {
                  children: /*#__PURE__*/jsx("span", {
                    id: `${id}-title`,
                    children: /*#__PURE__*/jsx(Message, {
                      id: `cookie.toggle.${intlNamespace}.title`
                    })
                  })
                }),
                subheading: /*#__PURE__*/jsx(Heading06, {
                  component: "p",
                  children: /*#__PURE__*/jsx("span", {
                    id: describedBy,
                    children: /*#__PURE__*/jsx(Message, {
                      id: `cookie.toggle.${intlNamespace}.text`
                    })
                  })
                })
              })
            }), showSwitch && /*#__PURE__*/jsx(Suspense, {
              fallback: null,
              children: /*#__PURE__*/jsx(FormikSwitch, {
                ref: ref,
                "aria-describedby": describedBy,
                "aria-labelledby": `${id}-title`,
                disabled: disabled,
                name: name,
                id: id
              })
            })]
          })
        })
      })
    })
  );
};
Toggle.displayName = 'Toggle';
var Toggle$1 = Toggle;

const root$1 = {
  default: "d1bqxd8q",
  inline: "ip1vx4p"
};
const getClassNames$1 = _ref => {
  let {
    inline
  } = _ref;
  return {
    root: cx$1(root$1.default, inline && root$1.inline)
  };
};

const CDN = 'https://tags.tiqcdn.com/utag';
const ACCOUNT = 'gpl';
const OPTOUT_COOKIE = 'OPTOUTMULTI';
const INTERACTION_COOKIE = 'pwinteraction';
const APP_KEY_CONSENT_API = 'recomm-consent-api';
const InteractionDuration = {
  OPT_IN: 90,
  OPT_OUT: 30
};
let Design;
(function (Design) {
  Design[Design["INLINE"] = 0] = "INLINE";
  Design[Design["MODAL"] = 1] = "MODAL";
})(Design || (Design = {}));
const ConsentKeys = {
  EMAIL_ACCOUNT_SUMMARY: 'EMAIL_ACCOUNT_SUMMARY',
  EMAIL_PROMOTIONAL: 'EMAIL_PROMOTIONAL',
  EMAIL_NOTIFICATION: 'EMAIL_NOTIFICATION',
  SMS_PROMOTIONAL: 'SMS_PROMOTIONAL',
  VOICE_PROMOTIONAL: 'VOICE_PROMOTIONAL',
  DIRECT_MAIL_GENERAL: 'DIRECT_MAIL_GENERAL'
};
const ConsentKeysV1ToV2 = {
  account: 'EMAIL_ACCOUNT_SUMMARY',
  marketing: 'EMAIL_PROMOTIONAL',
  news: 'EMAIL_NOTIFICATION',
  phone: 'VOICE_PROMOTIONAL',
  post: 'DIRECT_MAIL_GENERAL',
  sms: 'SMS_PROMOTIONAL'
};

const getOrderedCookieKeys = (cookies, order) => {
  return Object.keys(cookies).filter(key => order.includes(key)).sort((a, b) => {
    return order.indexOf(a) > order.indexOf(b) ? 1 : -1;
  });
};

const ToggleGroup = _ref => {
  let {
    cookies,
    order,
    design,
    formKey
  } = _ref;
  const orderedCookieKeys = getOrderedCookieKeys(cookies, order);
  const classNames = getClassNames$1({
    inline: design === Design.INLINE
  });
  return /*#__PURE__*/jsxs("div", {
    className: classNames.root,
    children: [orderedCookieKeys.map(cookie => {
      if (cookie === 'essential') {
        return null;
      }
      return /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(Toggle$1, {
          formKey: formKey,
          name: cookie,
          intlNamespace: cookie
        })
      }, cookie);
    }), /*#__PURE__*/jsx(Toggle$1, {
      formKey: formKey,
      name: "essential",
      intlNamespace: "essential",
      showSwitch: false,
      disabled: true
    })]
  });
};
ToggleGroup.displayName = 'ToggleGroup';
var ToggleGroup$1 = ToggleGroup;

const classNames$4 = {
  underline: "u1s93zlp"
};

const RichTextMessage = _ref => {
  let {
    id,
    values
  } = _ref;
  const intl = useIntl();
  const makeLinks = () => {
    const links = {};
    for (let index = 1; index < 11; index = index + 1) {
      links[`link${index}`] = /*#__PURE__*/jsx(TextButton, {
        href: intl.formatMessage({
          id: `${id}.link${index}.url`,
          defaultMessage: ''
        }),
        target: "_blank",
        size: Size.INHERIT,
        children: /*#__PURE__*/jsx(Message, {
          id: `${id}.link${index}.text`
        })
      });
    }
    return links;
  };
  const RICH_TAGS = {
    p: chunks => /*#__PURE__*/jsx(BodyCopy, {
      children: chunks
    }),
    b: chunks => /*#__PURE__*/jsx("strong", {
      children: chunks
    }),
    em: chunks => /*#__PURE__*/jsx("em", {
      children: chunks
    }),
    u: chunks => /*#__PURE__*/jsx("span", {
      className: classNames$4.underline,
      children: chunks
    }),
    ...makeLinks()
  };
  return /*#__PURE__*/jsx(Message, {
    id: id,
    values: {
      ...RICH_TAGS,
      ...values
    }
  });
};
RichTextMessage.displayName = 'RichTextMessage';
var RichTextMessage$1 = RichTextMessage;

const root = {
  default: "d26bk07"
};
const text = {
  default: "dscyr28"
};
const aside = {
  default: "dlxdxbb",
  visible: "vdlf7x3"
};
const title = {
  default: "d1v0z0f8"
};
const description = "d2p089i";
const getClassNames = props => ({
  root: root.default,
  aside: cx$1(aside.default, props.showAction && aside.visible),
  text: text.default,
  title: title.default,
  description: cx$1(description, classNames$5.content)
});

const Header = _ref => {
  let {
    intlNamespace,
    action,
    showAction,
    privacyPolicyUrl
  } = _ref;
  const classNames = getClassNames({
    showAction
  });
  return /*#__PURE__*/jsxs("header", {
    className: classNames.root,
    children: [/*#__PURE__*/jsxs("section", {
      className: classNames.text,
      children: [/*#__PURE__*/jsx(Heading04, {
        className: classNames.title,
        children: /*#__PURE__*/jsx(Message, {
          id: `cookie.${intlNamespace}.title`
        })
      }), /*#__PURE__*/jsxs("div", {
        className: classNames.description,
        children: [/*#__PURE__*/jsx(RichTextMessage$1, {
          id: `cookie.${intlNamespace}.description`
        }), ' ', privacyPolicyUrl != null && /*#__PURE__*/jsx(TextButton, {
          href: privacyPolicyUrl,
          target: "_blank",
          children: /*#__PURE__*/jsx(Message, {
            id: 'cookie.privacyPolicy'
          })
        })]
      })]
    }), /*#__PURE__*/jsx("div", {
      className: classNames.aside,
      children: action
    })]
  });
};
Header.displayName = 'Header';
var Header$1 = Header;

const getButtonStatus = status => {
  switch (status) {
    case 'loading':
      return Status.PENDING;
    case 'success':
      return Status.SUCCESS;
    case 'error':
      return Status.FAILURE;
    case 'idle':
    default:
      return Status.DEFAULT;
  }
};

const makeFetchInteraction = cookies => {
  return () => {
    const cookie = cookies.get(INTERACTION_COOKIE);
    return Promise.resolve(cookie);
  };
};
var makeFetchInteraction$1 = makeFetchInteraction;

const makeFetchConsent = Consent => {
  const consent = new Consent();
  return order => {
    return Promise.resolve(consent.getByOrder(order));
  };
};
var makeFetchConsent$1 = makeFetchConsent;

const driver = pipe(authDriver(), xray(), json(), bodyOnly())(fetch);

function makeFetchPreferences(customerId) {
  return () => {
    return driver({
      url: `/api/consent-v2/v2/customers/${customerId}/consents`,
      headers: {
        'X-App-Key': APP_KEY_CONSENT_API
      }
    });
  };
}

function makePutPreferences(customerId) {
  return _ref => {
    let {
      payload
    } = _ref;
    if (customerId == null) return Promise.resolve({
      createdConsents: [],
      failedConsents: [],
      updatedConsents: []
    });
    return driver({
      url: `/api/consent-v2/v2/customers/${customerId}/consents`,
      method: Method.PUT,
      data: payload,
      headers: {
        'Idempotency-Key': v4(),
        'X-App-Key': APP_KEY_CONSENT_API
      }
    });
  };
}

const hasConsented = values => {
  return Object.entries(values).filter(_ref => {
    let [key] = _ref;
    return key !== 'essential';
  }).filter(_ref2 => {
    let [, value] = _ref2;
    return value;
  }).length > 0;
};
const getInteractionDuration = values => {
  if (hasConsented(values)) {
    return InteractionDuration.OPT_IN;
  }
  return InteractionDuration.OPT_OUT;
};
const getCookieFormValues = consentValues => {
  var _consentValues$essent, _consentValues$essent2, _consentValues$analyt, _consentValues$analyt2, _consentValues$market, _consentValues$market2, _consentValues$suppor, _consentValues$suppor2;
  return {
    cookies: {
      essential: (_consentValues$essent = (_consentValues$essent2 = consentValues.essential) === null || _consentValues$essent2 === void 0 ? void 0 : _consentValues$essent2.value) != null ? _consentValues$essent : false,
      analytics: (_consentValues$analyt = (_consentValues$analyt2 = consentValues.analytics) === null || _consentValues$analyt2 === void 0 ? void 0 : _consentValues$analyt2.value) != null ? _consentValues$analyt : false,
      marketing: (_consentValues$market = (_consentValues$market2 = consentValues.marketing) === null || _consentValues$market2 === void 0 ? void 0 : _consentValues$market2.value) != null ? _consentValues$market : false,
      support: (_consentValues$suppor = (_consentValues$suppor2 = consentValues.support) === null || _consentValues$suppor2 === void 0 ? void 0 : _consentValues$suppor2.value) != null ? _consentValues$suppor : false
    }
  };
};

// copied from utag.js to keep the same solution to setting the cookie
// this will take the domain + tld even if we have .co.uk
// account.123-reg.co.uk -> .123-reg.co.uk
// ote.123-reg.co.uk -> .123-reg.co.uk
const getDomain = window => {
  var _window$utag, _window$utag$cfg;
  const tealiumDomain = (_window$utag = window.utag) === null || _window$utag === void 0 ? void 0 : (_window$utag$cfg = _window$utag.cfg) === null || _window$utag$cfg === void 0 ? void 0 : _window$utag$cfg.domain;
  if (tealiumDomain != null) {
    return tealiumDomain;
  }
  try {
    const hostname = `${window.location.hostname}`;
    const hostnameParts = hostname.split('.');
    const pathSplit = /\.co\.|\.com\.|\.org\.|\.edu\.|\.net\.|\.asn\./.test(hostname) ? 3 : 2;
    const domain = hostnameParts.splice(hostnameParts.length - pathSplit, pathSplit).join('.');
    return domain;
  } catch (e) {
    return window.location.hostname;
  }
};

const makeSaveInteraction = (cookies, window) => {
  return expires => {
    const now = new Date();
    cookies.set(INTERACTION_COOKIE, JSON.stringify({
      value: 'yes',
      timestamp: now.toDateString()
    }), {
      expires,
      domain: getDomain(window)
    });
    return Promise.resolve();
  };
};
var makeSaveInteraction$1 = makeSaveInteraction;

const getEnvironment = () => {
  try {
    return TEALIUM_ENVIRONMENT;
  } catch (e) {
    return 'dev';
  }
};
const loadTealium = profile => {
  let isLoaded = false;
  return () => {
    if (isLoaded) {
      return Promise.resolve();
    }
    const env = getEnvironment();
    const url = `${CDN}/${ACCOUNT}/${profile}/${env}/utag.js`;
    const scriptLoaded = document.querySelector(`script[src="${url}"]`) != null;
    if (scriptLoaded) {
      isLoaded = true;
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      const body = document.querySelector('body');
      if (body == null) {
        return reject();
      }
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => {
        resolve();
        isLoaded = true;
      };
      script.onerror = reject;
      script.type = 'text/javascript';
      script.async = true;
      body.appendChild(script);
    });
  };
};
var makeLoadTealium = loadTealium;

// make safe copy of given object
// remove essential and default values since they would pollute the data
// send in opted in if any of the remaining options are true
const sendOptedInEvent = categoryValues => {
  const safeCategoryValues = {
    ...categoryValues
  };
  delete safeCategoryValues.default;
  delete safeCategoryValues.essential;
  const categoryValuesArray = Object.values(safeCategoryValues);
  const isOptedIn = categoryValuesArray.includes(true);
  if (isOptedIn) {
    // let anything listening that we opted in some cookies
    document.dispatchEvent(new CustomEvent('@upm/opted-in'));
  }
};
const makeSaveConsent = Consent => {
  return _ref => {
    let {
      categoryMap,
      categoryValues
    } = _ref;
    const config = Object.entries(categoryMap).reduce((acc, _ref2) => {
      let [key, {
        id
      }] = _ref2;
      return {
        ...acc,
        [id]: key
      };
    }, {});
    const consent = new Consent(config);
    consent.set(categoryValues);
    sendOptedInEvent(categoryValues);
    return Promise.resolve();
  };
};
var makeSaveConsent$1 = makeSaveConsent;

const makeUpdateUtagData = window => {
  return async () => {
    var _window$utag, _window$utag2;
    if (window !== null && window !== void 0 && (_window$utag = window.utag) !== null && _window$utag !== void 0 && _window$utag.data) {
      window.utag.data[`cp.${OPTOUT_COOKIE}`] = cookies.get(OPTOUT_COOKIE);
      await after(50);
      window.utag.data[`cp.${INTERACTION_COOKIE}`] = cookies.get(INTERACTION_COOKIE);
    }
    if (window !== null && window !== void 0 && (_window$utag2 = window.utag) !== null && _window$utag2 !== void 0 && _window$utag2.view) {
      var _window$utag$data, _window$utag3;
      window.utag.view((_window$utag$data = window === null || window === void 0 ? void 0 : (_window$utag3 = window.utag) === null || _window$utag3 === void 0 ? void 0 : _window$utag3.data) != null ? _window$utag$data : {});
    }
  };
};
var makeUpdateUtagData$1 = makeUpdateUtagData;

const makeCleanseCookies = (cookies, window) => allowlist => {
  const domain = getDomain(window);
  Object.keys(cookies.all()).forEach(cookie => {
    if (cookie === OPTOUT_COOKIE) {
      return;
    }
    if (allowlist.includes(cookie)) {
      return;
    }
    cookies.erase(cookie, {
      domain
    });
  });
};
var makeCleanseCookies$1 = makeCleanseCookies;

const useInitializeTealium = () => {
  var _brandConfig$analytic, _brandConfig$analytic2, _brandConfig$analytic3;
  const brandConfig = useBrandConfig();
  const profile = (_brandConfig$analytic = brandConfig === null || brandConfig === void 0 ? void 0 : (_brandConfig$analytic2 = brandConfig.analytics) === null || _brandConfig$analytic2 === void 0 ? void 0 : (_brandConfig$analytic3 = _brandConfig$analytic2.tealium) === null || _brandConfig$analytic3 === void 0 ? void 0 : _brandConfig$analytic3.profile) != null ? _brandConfig$analytic : '';
  return useMemo(() => makeLoadTealium(profile), [profile]);
};
var useInitializeTealium$1 = useInitializeTealium;

const useUpdateUtagData = () => {
  const window = useWindow();
  return makeUpdateUtagData$1(window);
};
var useUpdateUtagData$1 = useUpdateUtagData;

const useInitialValues = consent => {
  return useMemo(() => {
    const consentFlags = Object.entries(consent).reduce((acc, _ref) => {
      let [key, {
        value
      }] = _ref;
      return {
        ...acc,
        [key]: value
      };
    }, {});
    return {
      ...consentFlags,
      essential: true,
      // this is here to ensure the 'essential' is always checked
      default: true
    };
  }, [consent]);
};
const useOnSubmit$1 = _ref2 => {
  let {
    consent,
    saveConsent,
    saveInteraction,
    resetConsent
  } = _ref2;
  const updateUtagData = useUpdateUtagData$1();
  const loadTealium = useInitializeTealium$1();
  return async (values, _ref3) => {
    let {
      resetForm
    } = _ref3;
    await saveConsent({
      categoryMap: consent,
      categoryValues: values
    });

    // This does need to set the interaction as well as the user may have landed on privacy page to begin with
    // and then make some tuning and then go to the homepage...
    const expiry = getInteractionDuration(values);
    await saveInteraction(expiry);
    // Reset the status after a while
    await after(1000);
    resetConsent();
    resetForm({
      values
    });
    await loadTealium();
    updateUtagData();
  };
};

const InlineForm$1 = _ref => {
  let {
    consent,
    order,
    privacyPolicyUrl,
    submitStatus,
    onSubmit
  } = _ref;
  const initialValues = useInitialValues(consent);
  const buttonStatus = getButtonStatus(submitStatus);
  return /*#__PURE__*/jsx(PaddingBox, {
    children: /*#__PURE__*/jsx(Formik, {
      initialValues: initialValues,
      enableReinitialize: true,
      onSubmit: onSubmit,
      children: _ref2 => {
        let {
          dirty
        } = _ref2;
        return /*#__PURE__*/jsxs(Form, {
          children: [/*#__PURE__*/jsx(PaddingBox, {
            side: Side.X,
            children: /*#__PURE__*/jsx(Header$1, {
              intlNamespace: "inline",
              privacyPolicyUrl: privacyPolicyUrl,
              showAction: dirty,
              action: /*#__PURE__*/jsx(Button, {
                type: "submit",
                status: buttonStatus,
                children: /*#__PURE__*/jsx(Message, {
                  cascade: [{
                    id: 'cookie.save'
                  }, {
                    id: 'cookie.confirm'
                  }]
                })
              })
            })
          }), /*#__PURE__*/jsx(PaddingBox, {
            side: Side.Y,
            children: /*#__PURE__*/jsx(ToggleGroup$1, {
              formKey: FormKey.INLINE,
              design: Design.INLINE,
              cookies: consent,
              order: order
            })
          })]
        });
      }
    })
  });
};
InlineForm$1.displayName = 'InlineForm';
var InlineForm$2 = InlineForm$1;

const QUERY_KEY$2 = '@pex/upm/consent';
const useConsent = (fetchConsent, order, opts) => {
  // @ts-ignore I dont understand the warning
  return useQuery([QUERY_KEY$2, order], () => fetchConsent(order), {
    staleTime: Infinity,
    ...opts
  });
};
var useConsent$1 = ((order, opts) => {
  var _opts$suspense;
  return useConsent(makeFetchConsent$1(CookieConsent), order,
  // If the caller uses suspense, we need to pass that along,
  // or else we can end up in a state where useConsent returns before tealium is loaded
  {
    suspense: (_opts$suspense = opts === null || opts === void 0 ? void 0 : opts.suspense) != null ? _opts$suspense : false
  });
});

var useRefetchConsent = (() => {
  const queryCache = useQueryClient();
  return () => {
    queryCache.invalidateQueries(QUERY_KEY$2);
  };
});

const useSaveConsent = _ref => {
  let {
    refetch,
    saveConsent
  } = _ref;
  return useMutation(saveConsent, {
    onSuccess: refetch
  });
};
function useUseSaveConsent() {
  return useSaveConsent({
    refetch: useRefetchConsent(),
    saveConsent: makeSaveConsent$1(CookieConsent)
  });
}

const QUERY_KEY$1 = '@pex/upm/windowLoaded';

// This function is designed to return whether the window has loaded or not.
// We can't really utilise `window.onload` as it has a race condition to how
// fast you can apply that event listener to how fast the page actually loads.
// As such this function instead polls the document ready state (essentially the imperative version) of onload
// until it gets a state it so desires at which point it will resolve the query.
// This underlying goal here of why we are doing this is to delay the modal from opening
// until the DOM is ready and other things have been processed. Aka why use the CPU network
// for loading / running the cookie modal when the user can't even interact with it yet.
// It is better to utilise those resources on fetching pages, rendering ribbons, etc.
const useWindowLoaded = opts => {
  const document = useDocument();
  const fn = () => new Promise((res, rej) => {
    // Undecided which is better, just complete or interactive
    // document.readyState === 'complete' || document.readyState === 'interactive'
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
    if (document.readyState === 'complete') {
      return res(true);
    }
    rej(new Error('not ready'));
  });
  return useQuery(QUERY_KEY$1, fn, {
    staleTime: Infinity,
    retry: true,
    retryDelay: 100,
    ...opts
  });
};
var useWindowLoaded$1 = useWindowLoaded;

const QUERY_KEY = '@pex/upm/interaction';

// We wait for tealium to be loaded here as it auto populates the opt out cookie
// with some pre-false values that we can then use for category mapping
const useInteraction = (fetchInteraction, loaded, opts) => {
  return useQuery(QUERY_KEY, fetchInteraction, {
    staleTime: Infinity,
    enabled: loaded,
    ...opts
  });
};
var useInteraction$1 = (opts => {
  const fetchInteraction = makeFetchInteraction$1(cookies);
  return useInteraction(fetchInteraction, Boolean(useWindowLoaded$1().data), opts);
});

var useRefetchInteraction = (() => {
  const queryCache = useQueryClient();
  return () => {
    queryCache.invalidateQueries(QUERY_KEY);
  };
});

const useSaveInteraction = _ref => {
  let {
    refetch,
    saveInteraction
  } = _ref;
  return useMutation(saveInteraction, {
    onSuccess: refetch
  });
};
function useUseSaveInteraction() {
  const window = useWindow();
  return useSaveInteraction({
    refetch: useRefetchInteraction(),
    saveInteraction: makeSaveInteraction$1(cookies, window)
  });
}

const useCleanseCookies = (cleanseCookies, allowlist) => {
  return values => {
    // we only want to cleanse cookies when the user has opted out
    if (!hasConsented(values)) {
      cleanseCookies(allowlist);
    }
  };
};
function useUseCleanseCookies(allowlist) {
  const window = useWindow();
  const cleanseCookies = makeCleanseCookies$1(cookies, window);
  return useCleanseCookies(cleanseCookies, allowlist);
}

const PREFERENCES_QUERY_KEY = '@pex/upm/preferences';
const getPreferenceValueByKey = (preferences, key) => {
  var _preferenceFound$valu;
  const preferenceFound = preferences === null || preferences === void 0 ? void 0 : preferences.consents.find(pref => pref.consentKey === key);
  return (_preferenceFound$valu = preferenceFound === null || preferenceFound === void 0 ? void 0 : preferenceFound.value) != null ? _preferenceFound$valu : false;
};
const mapData = response => ({
  email: {
    // NOTE: Setting the essential property to true as the api does not return any value and
    // user does not have provision to opt out
    essential: true,
    account: getPreferenceValueByKey(response, ConsentKeys.EMAIL_ACCOUNT_SUMMARY),
    marketing: getPreferenceValueByKey(response, ConsentKeys.EMAIL_PROMOTIONAL),
    news: getPreferenceValueByKey(response, ConsentKeys.EMAIL_NOTIFICATION)
  },
  otherMethods: {
    sms: getPreferenceValueByKey(response, ConsentKeys.SMS_PROMOTIONAL),
    phone: getPreferenceValueByKey(response, ConsentKeys.VOICE_PROMOTIONAL),
    post: getPreferenceValueByKey(response, ConsentKeys.DIRECT_MAIL_GENERAL)
  }
});
function usePreferences(args, opts) {
  const {
    customerId,
    token
  } = args;

  // @ts-ignore: Don't understand the typescript error
  const {
    data,
    ...rest
  } = useQuery([PREFERENCES_QUERY_KEY, token], () => makeFetchPreferences(customerId)({
    token
  }), {
    ...opts,
    enabled: customerId != null
  });
  return {
    data: mapData(data),
    ...rest
  };
}

/**
 * Transforms put response into PreferencesResponse that is stored in the react-query cache.
 * @param newData The response of type ModifiedPreferencesResponse from the put api
 * @param oldData The cached value of the preferences of type PreferencesResponse from react-query cache
 * @returns A PreferencesResponse object containing the modified preferences
 */
const transformResponse = function (newData) {
  let oldData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    consents: []
  };
  const response = {
    consents: []
  };
  const createdConsents = newData['createdConsents'];
  const updatedConsents = newData['updatedConsents'];
  for (const oldConsent of oldData.consents) {
    const updatedConsent = updatedConsents.find(uc => uc.consentKey === oldConsent.consentKey);
    response.consents.push(updatedConsent ? {
      ...oldConsent,
      ...updatedConsent
    } : {
      ...oldConsent
    });
  }
  for (const createdConsent of createdConsents) {
    response.consents.push({
      ...createdConsent
    });
  }
  return response;
};
function usePutPreferences(customerId, token) {
  const cache = useQueryClient();
  const onSuccess = data => {
    // We don't want to refetch here, since the values won't change anything inside the formik context.
    // We do however want to keep the data in the cache up to date if the user should
    // navigate back and forth
    cache.setQueryData([PREFERENCES_QUERY_KEY, token], transformResponse(data, cache.getQueryData([PREFERENCES_QUERY_KEY, token])));
  };
  return useMutation(makePutPreferences(customerId), {
    onSuccess
  });
}

function useLoadTealium() {
  const {
    data
  } = useInteraction$1();
  const loadTealium = useInitializeTealium$1();
  const optoutMultiCookie = get(OPTOUT_COOKIE);
  useEffect(() => {
    if (data != null && optoutMultiCookie != null) {
      loadTealium();
    }
  }, [data, loadTealium, optoutMultiCookie]);
}

const ConnectedInlineForm = props => {
  const {
    mutateAsync: saveConsent,
    status: submitStatus,
    reset
  } = useUseSaveConsent();
  const {
    mutateAsync: saveInteraction
  } = useUseSaveInteraction();
  useLoadTealium();
  const onSubmit = useOnSubmit$1({
    consent: props.consent,
    resetConsent: reset,
    saveConsent,
    saveInteraction
  });
  return /*#__PURE__*/jsx(InlineForm$2, {
    ...props,
    submitStatus: submitStatus,
    onSubmit: onSubmit
  });
};
ConnectedInlineForm.displayName = 'ConnectedInlineForm';
var InlineForm = ConnectedInlineForm;

const classNames$3 = {
  loader: "l1f0q5nq"
};
function InlinePrivacy(_ref) {
  let {
    consent,
    consentStatus,
    order,
    privacyPolicyUrl
  } = _ref;
  if (consentStatus === 'idle') {
    return null;
  }
  if (consentStatus === 'loading') {
    return /*#__PURE__*/jsx(PaddingBox, {
      className: classNames$3.loader,
      children: /*#__PURE__*/jsx(WubLoader, {
        color: cssTheme.palette.primary
      })
    });
  }
  if (consentStatus === 'error') {
    return /*#__PURE__*/jsx(PaddingBox, {
      children: /*#__PURE__*/jsx(Header$1, {
        privacyPolicyUrl: privacyPolicyUrl,
        intlNamespace: "inline"
      })
    });
  }
  return /*#__PURE__*/jsx(InlineForm, {
    privacyPolicyUrl: privacyPolicyUrl,
    consent: consent,
    order: order
  });
}

const ConnectedInlinePrivacy = _ref => {
  let {
    order,
    privacyPolicyUrl
  } = _ref;
  const {
    data: consent,
    status: consentStatus
  } = useConsent$1(order);
  const props = {
    order,
    privacyPolicyUrl,
    consent: consent,
    consentStatus
  };
  return /*#__PURE__*/jsx(InlinePrivacy, {
    ...props
  });
};
ConnectedInlinePrivacy.displayName = 'ConnectedInlinePrivacy';
var ConnectedInlinePrivacy$1 = ConnectedInlinePrivacy;

const footer = "fyxxmn2";
const buttons = "b8qxwp2";
const classNames$2 = {
  footer,
  buttons
};

const ModalForm$1 = _ref => {
  let {
    consent,
    order,
    showSettings,
    toggleSettings,
    privacyPolicyUrl,
    onSubmit
  } = _ref;
  return /*#__PURE__*/jsx(Formik, {
    initialValues: {
      // These all have to start as false for compliance.
      // The user can toggle them on themselves and apply, or they can batch accept / decline
      default: false,
      analytics: false,
      marketing: false,
      support: false,
      essential: true // except this one which cannot be unchecked
    },

    onSubmit: onSubmit,
    children: _ref2 => {
      let {
        submitForm,
        setValues,
        initialValues,
        values
      } = _ref2;
      const handleAcceptClick = () => {
        // Accept all cookies if the user has not changed the settings and the settings section is not expanded
        if (deepEqual(values, initialValues) === true && !showSettings) {
          setValues({
            default: true,
            analytics: true,
            marketing: true,
            support: true,
            essential: true
          });
        }
        submitForm();
      };
      const handleDeclineClick = () => {
        setValues({
          default: false,
          analytics: false,
          marketing: false,
          support: false,
          essential: true
        });
        submitForm();
      };
      return /*#__PURE__*/jsx(Form, {
        children: /*#__PURE__*/jsxs(PaddingBox, {
          children: [/*#__PURE__*/jsx(Header$1, {
            intlNamespace: "modal",
            privacyPolicyUrl: privacyPolicyUrl
          }), /*#__PURE__*/jsx("section", {
            children: /*#__PURE__*/jsx(AnimateHeight, {
              duration: 600,
              animateOpacity: true,
              height: showSettings ? 'auto' : 0,
              children: /*#__PURE__*/jsx(PaddingBox, {
                side: Side.T,
                children: /*#__PURE__*/jsx(ToggleGroup$1, {
                  formKey: FormKey.MODAL,
                  design: Design.MODAL,
                  cookies: consent,
                  order: order
                })
              })
            })
          }), /*#__PURE__*/jsxs(PaddingBox, {
            side: Side.T,
            component: "footer",
            className: classNames$2.footer,
            children: [/*#__PURE__*/jsx("div", {
              children: /*#__PURE__*/jsx(Button, {
                onClick: toggleSettings,
                kind: Kind.SECONDARY,
                children: /*#__PURE__*/jsx(Message, {
                  id: `cookie.settings.toggle.${showSettings ? 'close' : 'open'}`
                })
              })
            }), /*#__PURE__*/jsxs("div", {
              className: classNames$2.buttons,
              children: [/*#__PURE__*/jsx(Button, {
                onClick: handleDeclineClick,
                children: /*#__PURE__*/jsx(Message, {
                  id: "cookie.decline"
                })
              }), /*#__PURE__*/jsx(Button, {
                onClick: handleAcceptClick,
                children: /*#__PURE__*/jsx(Message, {
                  id: "cookie.accept"
                })
              })]
            })]
          })]
        })
      });
    }
  });
};
ModalForm$1.displayName = 'ModalForm';
var ModalForm$2 = ModalForm$1;

const useOnSubmit = _ref => {
  let {
    consent,
    cleanseCookies,
    saveConsent,
    saveInteraction,
    closeModal,
    loadTealium
  } = _ref;
  const updateUtagData = useUpdateUtagData$1();
  return async values => {
    await saveConsent({
      categoryMap: consent,
      categoryValues: values
    });
    cleanseCookies(values);
    // This does need to set the interaction as well as the user may have landed on privacy page to begin with
    // and then make some tuning and then go to the homepage...
    const expiry = getInteractionDuration(values);
    await saveInteraction(expiry);
    closeModal();
    await loadTealium();
    updateUtagData();
  };
};

const ConnectedModalForm = _ref => {
  let {
    allowlist,
    ...props
  } = _ref;
  const cleanseCookies = useUseCleanseCookies(allowlist);
  const {
    mutateAsync: saveConsent
  } = useUseSaveConsent();
  const {
    mutateAsync: saveInteraction
  } = useUseSaveInteraction();
  const closeModal = useCloseModal();
  const [showSettings, setShowSettings] = useState(false);
  const loadTealium = useInitializeTealium$1();
  const toggleSettings = () => {
    setShowSettings(!showSettings);
  };
  const onSubmit = useOnSubmit({
    consent: props.consent,
    cleanseCookies,
    closeModal,
    saveConsent,
    saveInteraction,
    loadTealium
  });
  return /*#__PURE__*/createElement(ModalForm$2, {
    ...props,
    showSettings,
    toggleSettings,
    onSubmit
  });
};
ConnectedModalForm.displayName = 'ConnectedModalForm';
var ModalForm = ConnectedModalForm;

const MODAL_ROUTE = '@upm/modal';

// This is called Actual as the external interface for this doesn't care that this needs to be
// lazy loaded in depending on whether or not the cookie says so.
// The wrapping PrivacyModal component deals with those concerns and we can have the actual gui for
// the modal here.

function PrivacyModalActual$1(_ref) {
  let {
    appId = 'root',
    ...props
  } = _ref;
  // So the justification for a modal route here instead and forcing the open on mount is because
  // we need for other areas of the parent application to know whether the modal is open so that
  // they can decide whether their modals need to open.
  // A prime example of this is some upcoming (might not be now when you read this) basket reminder modal.
  // You want that modal to open for the user but not if the UPM modal is open.

  const {
    current: appElement
  } = useRef(document.getElementById(appId));
  const push = usePush();
  useEffect(() => {
    push(MODAL_ROUTE);
  }, [push]);

  // We never want the modal to open if tealium hasn't loaded.
  // The consent query will remain in idle until tealium is loaded.
  if (props.status !== 'success') {
    return null;
  }
  return /*#__PURE__*/jsx(ModalRoute, {
    path: MODAL_ROUTE,
    render: () => {
      return /*#__PURE__*/jsx(Modal, {
        ariaHideApp: !!appElement,
        isOpen: true
        // We do not allow the modal to be closed via clicking the overlay
        // the user has to either accept or decline the consent.
        ,
        onRequestClose: () => {
          // We do not allow the modal to be closed via clicking the overlay
          // the user has to either accept or decline the consent.
        },
        style: {
          content: {
            padding: 0,
            bottom: 'auto',
            top: cssTheme.gu4,
            left: cssTheme.gu4,
            right: cssTheme.gu4,
            borderColor: cssTheme.palette.grey10,
            borderRadius: cssTheme.radius.panel,
            background: 'white',
            maxWidth: 740,
            margin: '0 auto',
            boxShadow: `0 0 4px ${cssTheme.palette.grey10}`
          }
        },
        children: /*#__PURE__*/jsx(ModalForm, {
          privacyPolicyUrl: props.privacyPolicyUrl,
          allowlist: props.allowlist,
          consent: props.consent,
          order: props.order
        })
      });
    }
  });
}
PrivacyModalActual$1.displayName = 'PrivacyModalActual';

const ConnectedPrivacyModalActual = _ref => {
  let {
    order,
    allowlist,
    privacyPolicyUrl
  } = _ref;
  const {
    data: consent,
    status
  } = useConsent$1(order);
  return /*#__PURE__*/createElement(PrivacyModalActual$1, {
    allowlist,
    order,
    consent: consent,
    status,
    privacyPolicyUrl
  });
};
ConnectedPrivacyModalActual.displayName = 'ConnectedPrivacyModalActual';
var PrivacyModalActual = ConnectedPrivacyModalActual;

const ConnectedPrivacyModal = _ref => {
  let {
    order,
    allowlist,
    privacyPolicyUrl
  } = _ref;
  const {
    data,
    status
  } = useInteraction$1();
  useLoadTealium();
  if (status !== 'success') {
    return null;
  }
  if (data != null) {
    return null;
  }

  // We want to return null for the fallback as it's entirely a modal, we do not want to
  // interfere with the page's DOM
  return /*#__PURE__*/createElement(PrivacyModalActual, {
    order,
    allowlist,
    privacyPolicyUrl
  });
};
ConnectedPrivacyModal.displayName = 'ConnectedPrivacyModal';
var ConnectedPrivacyModal$1 = ConnectedPrivacyModal;

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */ && prop.charCodeAt(1) === 110
  /* n */ && prop.charCodeAt(2) < 91;
}
/* Z+1 */);

function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(' ');
}

/**
 * This file contains an runtime version of `styled` component. Responsibilities of the component are:
 * - returns ReactElement based on HTML tag used with `styled` or custom React Component
 * - injects classNames for the returned component
 * - injects CSS variables used to define dynamic styles based on props
 */

// Workaround for rest operator
const restOp = (obj, keysToExclude) => Object.keys(obj).filter(prop => !keysToExclude.includes(prop)).reduce((acc, curr) => Object.assign(acc, {
  [curr]: obj[curr]
}), {}); // rest operator workaround

const warnIfInvalid = (value, componentName) => {
  if (process.env.NODE_ENV !== 'production') {
    if (typeof value === 'string' ||
    // eslint-disable-next-line no-self-compare
    typeof value === 'number' && isFinite(value)) {
      return;
    }
    const stringified = typeof value === 'object' ? JSON.stringify(value) : String(value); // eslint-disable-next-line no-console

    console.warn(`An interpolation evaluated to '${stringified}' in the component '${componentName}', which is probably a mistake. You should explicitly cast or transform the value to a string.`);
  }
}; // If styled wraps custom component, that component should have className property

function styled(tag) {
  return options => {
    if (process.env.NODE_ENV !== 'production') {
      if (Array.isArray(options)) {
        // We received a strings array since it's used as a tag
        throw new Error('Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup');
      }
    }
    const render = (props, ref) => {
      const {
        as: component = tag,
        class: className
      } = props;
      const rest = restOp(props, ['as', 'class']);
      let filteredProps; // Check if it's an HTML tag and not a custom element

      if (typeof component === 'string' && component.indexOf('-') === -1) {
        filteredProps = {}; // eslint-disable-next-line guard-for-in

        for (const key in rest) {
          if (key === 'as' || index(key)) {
            // Don't pass through invalid attributes to HTML elements
            filteredProps[key] = rest[key];
          }
        }
      } else {
        filteredProps = rest;
      }
      filteredProps.ref = ref;
      filteredProps.className = cx(filteredProps.className || className, options.class);
      const {
        vars
      } = options;
      if (vars) {
        const style = {}; // eslint-disable-next-line guard-for-in

        for (const name in vars) {
          const variable = vars[name];
          const result = variable[0];
          const unit = variable[1] || '';
          const value = typeof result === 'function' ? result(props) : result;
          warnIfInvalid(value, options.name);
          style[`--${name}`] = `${value}${unit}`;
        }
        filteredProps.style = Object.assign(style, filteredProps.style);
      }
      if (tag.__linaria && tag !== component) {
        // If the underlying tag is a styled component, forward the `as` prop
        // Otherwise the styles from the underlying component will be ignored
        filteredProps.as = component;
        return /*#__PURE__*/React.createElement(tag, filteredProps);
      }
      return /*#__PURE__*/React.createElement(component, filteredProps);
    };
    const Result = React.forwardRef ? /*#__PURE__*/React.forwardRef(render) :
    // React.forwardRef won't available on older React versions and in Preact
    // Fallback to a innerRef prop in that case
    props => {
      const rest = restOp(props, ['innerRef']);
      return render(rest, props.innerRef);
    };
    Result.displayName = options.name; // These properties will be read by the babel plugin for interpolation

    Result.__linaria = {
      className: options.class,
      extends: tag
    };
    return Result;
  };
}
var styled$1 = process.env.NODE_ENV !== 'production' ? new Proxy(styled, {
  get(o, prop) {
    return o(prop);
  }
}) : styled;

const toggles = "tla6x41";
const section = "s15ptgi8";
const classNames$1 = {
  toggles,
  section
};

const FormSection = _ref => {
  let {
    children,
    sectionIntro
  } = _ref;
  return /*#__PURE__*/jsxs("section", {
    className: classNames$1.section,
    children: [sectionIntro, /*#__PURE__*/jsx("div", {
      className: classNames$1.toggles,
      children: children
    })]
  });
};
FormSection.displayName = 'FormSection';
var FormSection$1 = FormSection;

const classNames = {
  heading: "h1iewrxz",
  paddingBox: "p1rt6u7m"
};
const SectionIntro = _ref => {
  let {
    heading,
    body
  } = _ref;
  return /*#__PURE__*/jsx(PaddingBox, {
    className: classNames.paddingBox,
    children: /*#__PURE__*/jsx(Typelockup, {
      heading: /*#__PURE__*/jsx(Heading02, {
        className: classNames.heading,
        children: heading
      }),
      subheading: /*#__PURE__*/jsx(Heading06, {
        component: "p",
        children: body
      })
    })
  });
};
SectionIntro.displayName = 'SectionIntro';
var SectionIntro$1 = SectionIntro;

const CommunicationFormSection = () => {
  const {
    isSubmitting,
    values
  } = useFormikContext();
  return /*#__PURE__*/jsx(Fragment, {
    children: Object.keys(values).map(key => /*#__PURE__*/jsx(FormSection$1, {
      sectionIntro: /*#__PURE__*/jsx(SectionIntro$1, {
        heading: /*#__PURE__*/jsx(Message, {
          id: `cookie.communication.${key}.title`
        }),
        body: /*#__PURE__*/jsx(Message, {
          id: `cookie.communication.${key}.text`
        })
      }),
      children: Object.keys(values[key]).map(innerKey => {
        const toggleKey = `${key}.${innerKey}`;
        const intlNamespace = key === 'cookies' ? innerKey : toggleKey;
        return /*#__PURE__*/jsx(Toggle$1, {
          intlNamespace: intlNamespace,
          name: toggleKey,
          disabled: innerKey === 'essential' || isSubmitting,
          showSwitch: innerKey !== 'essential',
          formKey: FormKey.COMMUNICATION
        }, toggleKey);
      })
    }, key))
  });
};
CommunicationFormSection.displayName = 'CommunicationFormSection';
var CommunicationFormSection$1 = CommunicationFormSection;

function useOnPreferencesSubmitted() {
  const erk = useErk();
  const smirk = useSmirk();
  const {
    formatMessage
  } = useIntl();
  const onSuccess = () => {
    smirk({
      message: formatMessage({
        id: 'cookie.preferences.updateSuccess'
      })
    });
  };
  const onError = () => {
    erk({
      message: formatMessage({
        id: 'cookie.preferences.updateError'
      })
    });
  };
  return {
    onSuccess,
    onError
  };
}

function useCustomer() {
  const customer = getCustomer(useAuth());
  return customer;
}

const Section = /*#__PURE__*/styled$1("section")({
  name: "Section",
  class: "sef8num",
  vars: {
    "sef8num-0": [_ref => {
      let {
        isSticky
      } = _ref;
      return isSticky ? 'sticky' : 'static';
    }],
    "sef8num-1": [_ref2 => {
      let {
        bottomValue
      } = _ref2;
      return bottomValue;
    }]
  }
});
const ActionStrip = _ref3 => {
  let {
    children,
    sticky
  } = _ref3;
  const [isSticky, setSticky] = useState(sticky);
  const [bottomValue, setBottom] = useState(sticky ? 0 : '-200px');
  useEffect(() => {
    let timeout;
    if (sticky) {
      // animate in
      setSticky(sticky);
      setBottom(0);
      clearTimeout(timeout);
    } else {
      // animate out
      setBottom('-200px');

      // The duration of the animation is 500ms, so we allow it to animate out before we set position back to static
      timeout = setTimeout(() => {
        setSticky(false);
      }, 500);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [sticky, isSticky]);
  return /*#__PURE__*/jsx(Section, {
    isSticky: isSticky,
    bottomValue: bottomValue,
    children: /*#__PURE__*/jsx(Container, {
      children: /*#__PURE__*/jsx(PaddingBox, {
        children: /*#__PURE__*/jsx(CTAGroup, {
          children: children
        })
      })
    })
  });
};
ActionStrip.displayName = 'ActionStrip';
var ActionStrip$1 = ActionStrip;

const ResetCommunicationForm = () => {
  const {
    dirty,
    resetForm
  } = useFormikContext();
  const [modalInstance, Modal] = useCreateConfirmationModal();
  const toggleModal = () => {
    if (modalInstance.isOpen()) {
      modalInstance.close();
    } else {
      modalInstance.open();
    }
  };
  const handleConfirm = () => {
    resetForm();
    toggleModal();
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Button, {
      kind: Kind.SECONDARY,
      disabled: !dirty,
      onClick: toggleModal,
      children: /*#__PURE__*/jsx(Message, {
        id: "cookie.communication.form.cancel"
      })
    }), /*#__PURE__*/jsx(Modal, {
      eyebrow: /*#__PURE__*/jsx(Message, {
        id: "cookie.communication.form.reset.warning"
      }),
      heading: /*#__PURE__*/jsx(Message, {
        id: "cookie.communication.form.reset.heading"
      }),
      confirmButton: /*#__PURE__*/jsx(Button, {
        onClick: handleConfirm,
        kind: Kind.DETRIMENTAL,
        children: /*#__PURE__*/jsx(Message, {
          id: "cookie.communication.form.reset.confirm"
        })
      }),
      cancelButton: /*#__PURE__*/jsx(Button, {
        kind: Kind.TERTIARY,
        onClick: toggleModal,
        children: /*#__PURE__*/jsx(Message, {
          id: "cookie.communication.form.reset.keep"
        })
      })
    })]
  });
};
ResetCommunicationForm.displayName = 'ResetCommunicationForm';
var ResetCommunicationForm$1 = ResetCommunicationForm;

const order = ['essential', 'analytics', 'support', 'marketing'];
const preparePayload = payloadDiff => {
  const consentList = {
    consents: []
  };
  for (const [key, value] of Object.entries(payloadDiff)) {
    consentList.consents.push({
      consentKey: ConsentKeysV1ToV2[key],
      value: value
    });
  }
  return consentList;
};
const StyledForm = /*#__PURE__*/styled$1(Form)({
  name: "StyledForm",
  class: "s1stpa8a"
});
const CommunicationForm = _ref => {
  let {
    token
  } = _ref;
  const customer = useCustomer();
  const {
    data
  } = usePreferences({
    customerId: customer === null || customer === void 0 ? void 0 : customer.customerId,
    token
  }, {
    suspense: true
  });
  const {
    mutateAsync: putPreferences
  } = usePutPreferences(customer === null || customer === void 0 ? void 0 : customer.customerId, token);
  const {
    mutateAsync: saveConsent
  } = useUseSaveConsent();
  const {
    data: consent
  } = useConsent$1(order, {
    suspense: true
  });
  const cookies = getCookieFormValues(consent);
  const {
    onSuccess,
    onError
  } = useOnPreferencesSubmitted();
  const handleSubmit = async (values, _ref2) => {
    let {
      resetForm
    } = _ref2;
    try {
      const {
        email,
        otherMethods
      } = values;
      await Promise.all([putPreferences({
        token,
        payload: preparePayload(updatedDiff({
          ...data.email,
          ...data.otherMethods
        }, {
          ...email,
          ...otherMethods
        }))
      }), saveConsent({
        categoryMap: consent,
        categoryValues: values.cookies
      })]);
      resetForm({
        isSubmitting: false,
        values
      });
      onSuccess();
    } catch {
      resetForm({
        isSubmitting: false
      });
      onError();
    }
  };
  return /*#__PURE__*/jsx(Formik, {
    initialValues: {
      ...data,
      ...cookies
    },
    onSubmit: handleSubmit,
    children: _ref3 => {
      let {
        isSubmitting,
        dirty
      } = _ref3;
      return /*#__PURE__*/jsxs(StyledForm, {
        children: [/*#__PURE__*/jsx(Container, {
          children: /*#__PURE__*/jsx(CommunicationFormSection$1, {})
        }), /*#__PURE__*/jsxs(ActionStrip$1, {
          sticky: dirty,
          children: [/*#__PURE__*/jsx(Button, {
            status: isSubmitting ? Status.PENDING : Status.DEFAULT,
            type: "submit",
            children: /*#__PURE__*/jsx(Message, {
              id: "cookie.communication.form.save"
            })
          }), /*#__PURE__*/jsx(ResetCommunicationForm$1, {})]
        })]
      });
    }
  });
};
CommunicationForm.displayName = 'CommunicationForm';
var CommunicationForm$1 = CommunicationForm;

const Communication = _ref => {
  let {
    token
  } = _ref;
  return /*#__PURE__*/jsx(CommunicationForm$1, {
    token: token
  });
};
Communication.displayName = 'Communication';
var Communication$1 = Communication;

const ConnectedCommunication = _ref => {
  let {
    token = null
  } = _ref;
  return /*#__PURE__*/jsx(Communication$1, {
    token: token
  });
};
ConnectedCommunication.displayName = 'ConnectedCommunication';
var ConnectedCommunication$1 = ConnectedCommunication;

export { ConnectedCommunication$1 as Communication, ConnectedInlinePrivacy$1 as InlinePrivacy, ConnectedPrivacyModal$1 as PrivacyModal, useConsent$1 as useConsent, useUseSaveConsent as useSaveConsent };
